module.exports = __webpack_public_path__ + "static/material_widgets_recording-f16fdd801940f8f45dfebacf99dae713.mp4";